import { createContext } from "react";
import { CustomizationState, DispatchCustomizationAction } from "../states/customization";
import { Configuration } from "../types/customization/configuration";

export interface CustomizationContextType extends CustomizationState {
  configuration?: Configuration;
  dispatch: DispatchCustomizationAction;
}

const CustomizationContext = createContext<CustomizationContextType>(
  {} as CustomizationContextType
);

export default CustomizationContext;
